
























import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiDatePicker
  }
})
export default class DelayedProductionDialog extends BaseComponent {
  @Prop()
  permissions: any;

  showDialog: boolean = false;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {}
  };

  mounted() {
    this.showDialog = true;
    setTimeout(() => {
      this.$refs['justification'].focus();
    }, 500);
  }

  onOkClick() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.$emit('confirm');
  }

  onCancelClick() {
    this.$emit('cancel');
  }

  @Watch('permissions', { immediate: true })
  onPermissionsChange() {
    if (!this.permissions) {
      return;
    }
  }
}
